import type { RefObject } from 'react';

import { MarketSelectorPanelOnly } from '@src/components/MarketSelector/MarketSelectorPanelOnly';

import { useIsMobileLayout } from '../../../hooks/useIsMobileLayout';
import {
  usePredictionCardMarketSelector,
  type PredictionCardMarketSelectorParams,
} from './usePredictionCardMarketSelector';

interface PredictionCardMarketSelectorPanelProps extends PredictionCardMarketSelectorParams {
  isOpen: boolean;
  onClose: () => void;
  panelAnchorRef: RefObject<HTMLElement>;
  'data-testid'?: string;
}

export function PredictionCardMarketSelectorPanel({
  items,
  selectedMarketAccounts,
  selectedAggregation,
  onChangeSelectedMarketAccounts,
  isOpen,
  onClose,
  panelAnchorRef,
  'data-testid': dataTestId,
}: PredictionCardMarketSelectorPanelProps) {
  const isInMobileMode = useIsMobileLayout();
  const marketSelector = usePredictionCardMarketSelector({
    items,
    selectedMarketAccounts,
    selectedAggregation,
    onChangeSelectedMarketAccounts,
  });

  return (
    <MarketSelectorPanelOnly
      marketSelectorAPI={marketSelector}
      isOpen={isOpen}
      onClose={onClose}
      panelAnchorRef={panelAnchorRef}
      isNarrow={isInMobileMode}
      showCredentialsOnlyToggle
      testID={dataTestId}
    />
  );
}
